import {
  addMonths,
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  isSameDay,
  isSameMonth,
  isToday,
  startOfMonth,
  startOfWeek,
} from 'date-fns';

export type CalendarCell = {
  date: Date;
  inCurrentMonth: boolean;
  isToday: boolean;
};

/** Monday-start week to match most business calendars (locale can be swapped later). */
export function getMonthGrid(anchor: Date): CalendarCell[] {
  const monthStart = startOfMonth(anchor);
  const monthEnd = endOfMonth(anchor);
  const gridStart = startOfWeek(monthStart, { weekStartsOn: 1 });
  const gridEnd = endOfWeek(monthEnd, { weekStartsOn: 1 });

  return eachDayOfInterval({ start: gridStart, end: gridEnd }).map((date) => ({
    date,
    inCurrentMonth: isSameMonth(date, anchor),
    isToday: isToday(date),
  }));
}

export function shiftMonth(anchor: Date, delta: number): Date {
  return addMonths(anchor, delta);
}

export function formatMonthTitle(anchor: Date): string {
  return format(anchor, 'MMMM yyyy');
}

export function isSameDate(a: Date, b: Date): boolean {
  return isSameDay(a, b);
}
